import { LIMPAR_MAPA_VEICULO, SELECIONAR_MAPA_VEICULO } from '../../actions/types'

const initialState = undefined
const itemInicial = { nome: '', uf: null }

export default function reducerMapaVeiculo (state = itemInicial, action = initialState) {
  switch (action.type) {
    case SELECIONAR_MAPA_VEICULO: {
      return action.payload;
    }

    case LIMPAR_MAPA_VEICULO: {
      return itemInicial;
    }

    default: {
      return state
    }
  }
}
